import React, { useState, useEffect, useRef } from "react";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { useNavigate } from "react-router";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import Select from "react-select";
import { api_path } from "../../shared.js";
import swal from "sweetalert";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import DateBox from "devextreme-react/date-box";
import AddBoxIcon from "@mui/icons-material/AddBox";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
export function SaleInquiryFormContent(props) {
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };
  const [getUserRole, setUserRole] = useState(props.USER_ROLE);
  const [getUserID, setUserID] = useState(props.USER_EMAIL);
  const [getEmpID, setEmpID] = useState(props.EMP_CODE);
  const [searchParams] = useSearchParams();
  const id = searchParams.get("param1");
  const copy = searchParams.get("copy");
  const [containerInputs, setcontainerInputs] = useState([
    { getContainerSize: "", getContainerType: "", qty: "", TEU_NOTE: "" },
  ]);
  const [getBusinessType, setBusinessType] = useState([]);
  const [businessTypeList, setBusinessTypeList] = useState([]);
  const [selectBusinessType, setSelectBusinessType] = useState([]);
  const [getShipper, setShipper] = useState([]);
  const [shipperList, setShipperList] = useState([]);
  const [selectShipper, setSelectShipper] = useState([]);

  const [getOrigin, setOrigin] = useState([]);
  const [originList, setOriginList] = useState([]);
  const [selectOrigin, setSelectOrigin] = useState([]);
  const [getDestination, setDestination] = useState([]);
  const [destinationList, setDestinationList] = useState([]);
  const [selectDestination, setSelectDestination] = useState([]);
  const [getPor, setPor] = useState([]);
  const [porList, setPorList] = useState([]);
  const [selectPor, setSelectPor] = useState([]);

  const [getPol, setPol] = useState([]);
  const [polList, setPolList] = useState([]);
  const [selectPol, setSelectPol] = useState([]);

  const [getPod, setPod] = useState([]);
  const [podList, setPodList] = useState([]);
  const [selectPod, setSelectPod] = useState([]);

  const [getDel, setDel] = useState([]);
  const [delList, setDelList] = useState([]);
  const [selectDel, setSelectDel] = useState([]);

  const [getCommodity, setCommodity] = useState([]);
  const [commodityList, setCommodityList] = useState([]);
  const [selectCommodity, setSelectCommodity] = useState([]);

  const [getShipperDetail, setShipperDetail] = useState("");
  const [getCommodityDetail, setCommodityDetail] = useState("");
  const [getHSCODE, setHSCODE] = useState("");
  const [getCMB, setCMB] = useState("");
  const [packageType, setPackageType] = useState("");
  const [getDangerous, setDangerous] = useState(0);
  const [getDG, setDG] = useState("");
  const [qty, setQty] = useState("");
  const [weight, setWeight] = useState("");
  const [dimension, setDimension] = useState("");
  const [remark, setRemark] = useState("");
  const [getRemarkToCarrier, setRemarkToCarrier] = useState("");
  
  const [targetRate, setTargetRate] = useState("");
  const [getCarrier, setCarrier] = useState([]);
  const [carrierList, setCarrierList] = useState([]);
  const [selectCarrier, setSelectCarrier] = useState([]);

  const [getSale, setSale] = useState([]);
  const [saleList, setSaleList] = useState([]);
  const [selectSale, setSelectSale] = useState([]);

  const [getCopyTo, setCopyTo] = useState();
  const [copyToList, setCopyToList] = useState([]);
  const [selectCopyTo, setSelectCopyTo] = useState([]);
  const [getShipperName, setShipperName] = useState("");
  const [getBusinessName, setBusinessName] = useState("");
  const [getStatus, setStatus] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [selectStatus, setSelectStatus] = useState([]);
  const [subjectName, setSubjectName] = useState("");
  const [getDateStr, setDateStr] = useState(
    "Please click Search button to refresh data."
  );
  const [isSubmitting, setSubmitting] = useState(false);
  const [isButtonDisabled, setButtonDisabled] = useState(true);
  const [getSearchStatus, setSearchStatus] = useState(0);
  const [showDG, setShowDG] = useState(false);
  const [showDimension, setShowDimension] = useState(false);
  const [showPackageType, setShowPackageType] = useState(false);

  const [showTEU, setShowTEU] = useState(false);
  const [showShipperDetail, setShowShipperDetail] = useState(false);
  const [showUploadMsg, setShowUploadMsg] = useState(
    "Choose file before Pressing the Upload button."
  );
  const [getExpectEtd, setExpectEtd] = useState("");
  const [checkUplodaFile, setUplodaFile] = useState(false);
  const now = new Date();
  const dateLabel = { "aria-label": "Date" };
  var date = new Date();
  const formattedtoday2 = date
  .toLocaleDateString("en-GB", {
    year: "2-digit",
    month: "2-digit",
    day: "2-digit",
  })
  .split("/")
  .reverse()
  .join("");
  function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1) + min);
  }
  const [GET_RANDOM_KEY, SET_RANDOM_KEY] = useState(formattedtoday2+""+Math.floor(date.getTime()/1000));
  var firstDay = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate() + 1
  );
  var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, 0);
  const formattedfirstDay = firstDay
    .toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/")
    .reverse()
    .join("-");

  const formattedlastDay = lastDay
    .toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/")
    .reverse()
    .join("-");
    const [getDateFrom, setDateFrom] = useState();
    const [getDateTo, setDateTo] = useState();
  //  const [getDateFrom, setDateFrom] = useState(formattedfirstDay);
  //  const [getDateTo, setDateTo] = useState(formattedlastDay);
  const [getMinDate, setMinDate] = useState(null);
  const onValueChangedDateFrom = React.useCallback((e) => {
    setSearchStatus(0);
    const dateFrom = new Date(e.value);
    const formattedDateFrom = dateFrom
      .toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .split("/")
      .reverse()
      .join("-");
    setDateFrom(formattedDateFrom);
    setMinDate(formattedDateFrom);
  }, []);
  const onValueChangedDateTo = React.useCallback((e) => {
    setSearchStatus(0);
    const dateTo = new Date(e.value);
    const formattedDateTo = dateTo
      .toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .split("/")
      .reverse()
      .join("-");
    setDateTo(formattedDateTo);
  }, []);

  const [isValidPol, setIsValidPol] = useState(false);
  const [isValidPod, setIsValidPod] = useState(false);
  //////////////////
  const [newUserInfo, setNewUserInfo] = useState({
    profileImages: [],
  });
  const updateUploadedFiles = (files) =>
    setNewUserInfo({ ...newUserInfo, profileImages: files });

  ////////////////////////////////

  useEffect(() => {
    setIsValidPol(selectPol ? true : false);
  }, [selectPol]);
  useEffect(() => {
    setIsValidPod(selectPod ? true : false);
  }, [selectPod]);
  useEffect(() => {
    if (id > 0) {
      fetch(api_path + "/TS_SALES_INQUIRY_BY_ID.php?param1=" + id)
        .then((res) => res.json())
        .then((res) => {
          const array = res;
          for (const i of array) {
            setSelectStatus(i.REQUEST_STATUS);
            if (i.REQUEST_STATUS == 1) {
              setStatus({
                value: i.REQUEST_STATUS,
                label: "ไม่มีราคาในระบบ No rate in system",
              });
            } else if (i.REQUEST_STATUS == 2) {
              setStatus({
                value: i.REQUEST_STATUS,
                label: "มีราคาในระบบ แต่ต้องการต่อรองราคา",
              });
            } else if (i.REQUEST_STATUS == 3) {
              setStatus({
                value: i.REQUEST_STATUS,
                label: "ต้องการข้อมูลสายเรืออื่นเพิ่ม เพื่อการเปรียบเทียบราคา",
              });
            }

            setSelectBusinessType(i.BUSINESS_ID);
            setBusinessType({
              INQUIRY_MASTER_VALUE: i.BUSINESS_ID,
              INQUIRY_MASTER_EN: i.Business_name,
            });

            setShipper({
              CRM_CUSCODE: i.SHIPPER_ID,
              CUSTOMER_NAME: i.Customer_name,
            });
            setSelectShipper(i.SHIPPER_ID);
            setShipperDetail(i.SHIPPER_DETAIL);
            if (i.Customer_name == "N/A") {
              setShowShipperDetail(true);
            } else {
              setShowShipperDetail(false);
            }
            setOrigin({
              COUNTRY_NAME: i.COUNTRY,
              COUNTRY_CODE: i.COUNTRY,
            });
            setSelectOrigin(i.DESTINATION);

            setSelectCommodity(i.COMMODITY);
            setCommodity({
              COMMODITY_NAME: i.COMMODITY,
              COMMODITY_NAME: i.COMMODITY,
            });
            setCommodityDetail(i.COMMODITY_DETAIL);
            setOrigin({
              COUNTRY_NAME: i.COUNTRY_NAME,
              COUNTRY_CODE: i.COUNTRY,
            });
            setSelectOrigin(i.COUNTRY);
            setDestination({
              COUNTRY_NAME: i.DESTINATION_NAME,
              COUNTRY_CODE: i.DESTINATION,
            });
            setSelectDestination(i.DESTINATION);
            setPor(i.POR);
            setSelectPor(i.POR);
            setPol(i.POL);
            setSelectPol(i.POL);
            setSelectPod(i.POD);
            setSelectDel(i.DEL);
            setSelectCarrier(i.CARRIER);
            setSale({
              EmpEmail: i.SALESID,
              EmpEmail: i.SALESID,
            });
            setSelectSale(i.SALESID);
            //setSelectCopyTo(i.SALESTO);
            setTargetRate(i.TARGET_RATE);
            setRemark(i.REMARK);
            setRemarkToCarrier(i.REMARK_TO_CARRIER);
            setHSCODE(i.HS_CODE);
            setExpectEtd(i.EXPECT_ETD);
            if (
              i.BUSINESS_ID.replace(/^\s+|\s+$/g, "") == "SEA" ||
              i.BUSINESS_ID.replace(/^\s+|\s+$/g, "") == "REEFER" ||
              i.BUSINESS_ID.replace(/^\s+|\s+$/g, "") == "SOC" ||
              i.BUSINESS_ID.replace(/^\s+|\s+$/g, "") == "TANK"
            ) {
              setShowTEU(true);
              setShowDimension(false);
              setShowPackageType(false);
            } else if (
              i.BUSINESS_ID.replace(/^\s+|\s+$/g, "") == "WH" ||
              i.BUSINESS_ID.replace(/^\s+|\s+$/g, "") == "LCL" ||
              i.BUSINESS_ID.replace(/^\s+|\s+$/g, "") == "BREAKBULK"
            ) {
              setShowDimension(true);
              setShowTEU(false);
              setShowPackageType(false);
            } else if (i.BUSINESS_ID.replace(/^\s+|\s+$/g, "") == "AIR") {
              setShowPackageType(true);
              setShowDimension(true);
              setShowTEU(false);
            } else {
              setShowPackageType(false);
              setShowDimension(false);
            }
            setWeight(i.WEIGHT);
            setDimension(i.DIMENSION);
            setCMB(i.CBM);
            setPackageType(i.PACKAGE_TYPE);
            setQty(i.QUANTITY);
          }
        });
    } else {
      //setSelectSale("kornraphat.c@sinologistics.co.th");
    }
  }, [id]);

  useEffect(() => {
    //run one time only
    fetchBusinessType();
    //fetchShipper();
    fetchCountry();
    fetchCommodity();
    fetchSale();
    if (getUserRole == 1) {
      setSelectSale(getUserID);
      setSale({
        EmpEmail: getUserID,
        EmpEmail: getUserID,
      });
    }
  }, []);
  useEffect(() => {
    if (id > 0) {
      setSubjectName("Copy Inquiry");
    } else {
      setSubjectName("New Inquiry");
    }
  }, [id]);
  const fetchBusinessType = () => {
    axios
      .get(api_path + `/MS_INQUIRY_MASTER.php?type=BU`)
      .then((response) => {
        setBusinessTypeList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleBusinessTypeChange = (obj) => {
    if (
      obj.INQUIRY_MASTER_VALUE == "SEA" ||
      obj.INQUIRY_MASTER_VALUE == "REEFER" ||
      obj.INQUIRY_MASTER_VALUE == "SOC" ||
      obj.INQUIRY_MASTER_VALUE == "TANK"
    ) {
      setShowTEU(true);
      setShowDimension(false);
      setShowPackageType(false);
    } else {
      setShowTEU(false);
    }
    if (
      obj.INQUIRY_MASTER_VALUE == "WH" ||
      obj.INQUIRY_MASTER_VALUE == "LCL" ||
      obj.INQUIRY_MASTER_VALUE == "BREAKBULK"
    ) {
      setShowDimension(true);
      setShowTEU(false);
      setShowPackageType(false);
    } else if (obj.INQUIRY_MASTER_VALUE == "AIR") {
      setShowPackageType(true);
      setShowDimension(true);
      setShowTEU(false);
    } else {
      setShowPackageType(false);
      setShowDimension(false);
    }
    setSelectBusinessType(obj.INQUIRY_MASTER_VALUE);
    setBusinessType({
      INQUIRY_MASTER_VALUE: obj.INQUIRY_MASTER_VALUE,
      INQUIRY_MASTER_EN: obj.INQUIRY_MASTER_EN,
    });
  };

  useEffect(() => {
    const getShipperDropdown = async () => {
      const resstate = await fetch(
        api_path +
          `/MS_CUSTOMER.php?SALES_CODE=` +
          getEmpID +
          `&role=` +
          getUserRole
      );
      const getst = resstate.json();
      setShipperList(await getst);
    };
    getShipperDropdown().then();
  }, []);
  const handleShipperChange = (obj) => {
    if (obj.CUSTOMER_NAME == "N/A") {
      setShowShipperDetail(true);
    } else {
      setShowShipperDetail(false);
    }
    setSelectShipper(obj.CRM_CUSCODE);
    setShipperName(obj.CUSTOMER_NAME);
    setShipper({
      CRM_CUSCODE: obj.CRM_CUSCODE,
      CUSTOMER_NAME: obj.CUSTOMER_NAME,
    });
  };
  const fetchCountry = () => {
    axios
      .get(api_path + `/GET_COUNTRY.php?ALL=1`)
      .then((response) => {
        setOriginList(response.data);
        setDestinationList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleOriginChange = (obj) => {
    setSelectOrigin(obj.COUNTRY_CODE);
    setOrigin({
      COUNTRY_CODE: obj.COUNTRY_CODE,
      COUNTRY_NAME: obj.COUNTRY_NAME,
    });
  };
  const handleDestinationChange = (obj) => {
    setSelectDestination(obj.COUNTRY_CODE);
    setDestination({
      COUNTRY_CODE: obj.COUNTRY_CODE,
      COUNTRY_NAME: obj.COUNTRY_NAME,
    });
  };
  useEffect(() => {
    const getPorDropdown = async () => {
      const resstate = await fetch(
        api_path + `/MS_ISO_PORT.php?COUNTRY_CODE=` + selectOrigin
      );
      const getst = resstate.json();
      setPorList(await getst);
    };
    getPorDropdown().then();
  }, [selectOrigin]);
  const handlePorChange = (obj) => {
    setSelectPor(Array.isArray(obj) ? obj.map((x) => x.value).join(",") : []);
    setPor({
      value: obj.value,
      label: obj.label,
    });
  };
  useEffect(() => {
    const getPolDropdown = async () => {
      const resstate = await fetch(
        api_path + `/MS_ISO_PORT.php?COUNTRY_CODE=` + selectOrigin
      );
      const getst = resstate.json();
      setPolList(await getst);
    };
    getPolDropdown().then();
  }, [selectOrigin]);
  const handlePolChange = (obj) => {
    setDateStr("Please click Search button to refresh data.");
    setSearchStatus(0);
    setSelectPol(Array.isArray(obj) ? obj.map((x) => x.value).join(",") : []);
    setPol({
      value: obj.PORT_CODE,
      label: obj.PORT_CODE,
    });
  };

  useEffect(() => {
    const getPodDropdown = async () => {
      const resstate = await fetch(
        api_path + `/MS_ISO_PORT.php?COUNTRY_CODE=` + selectDestination
      );
      const getst = resstate.json();
      setPodList(await getst);
    };
    getPodDropdown().then();
  }, [selectDestination]);
  const handlePodChange = (obj) => {
    setSelectPod(Array.isArray(obj) ? obj.map((x) => x.value).join(",") : []);
    setPod({
      value: obj.PORT_CODE,
      label: obj.PORT_CODE,
    });
  };
  const handleDelChange = (obj) => {
    setSelectDel(Array.isArray(obj) ? obj.map((x) => x.value).join(",") : []);
    setDel({
      value: obj.PORT_CODE,
      label: obj.PORT_CODE,
    });
  };

  const handleStatusChange = (obj) => {
    setSelectStatus(obj.value);
    setStatus({ value: obj.value, label: obj.label });
  };
  const fetchCommodity = () => {
    axios
      .get(api_path + `/MS_COMMODITY.php`)
      .then((response) => {
        setCommodityList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleCommodityChange = (obj) => {
    setSelectCommodity(obj.COMMODITY_NAME);
    setCommodity({
      COMMODITY_NAME: obj.COMMODITY_NAME,
      COMMODITY_NAME: obj.COMMODITY_NAME,
    });
  };
  useEffect(() => {
    const getCarrierDropdown = async () => {
      const resstate = await fetch(api_path + `/MS_CARRIER.php`);
      const getst = resstate.json();
      setCarrierList(await getst);
    };
    getCarrierDropdown().then();
  }, [selectCarrier]);
  const handleCarrierChange = (obj) => {
    setDateStr("Please click Search button to refresh data.");
    setSearchStatus(0);
    setSelectCarrier(
      Array.isArray(obj) ? obj.map((x) => x.value).join(",") : []
    );
    setCarrier({
      value: obj.CARRIER_CODE,
      label: obj.CARRIER_NAME,
    });
  };
  const fetchSale = () => {
    axios
      .get(api_path + `/sales.php`)
      .then((response) => {
        setSaleList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleSaleChange = (obj) => {
    setSelectSale(obj.EmpEmail);
    setSale({ EmpEmail: obj.EmpEmail, EmpEmail: obj.EmpEmail });
  };
  useEffect(() => {
    const getCopyToDropdown = async () => {
      const resstate = await fetch(api_path + `/sales.php?ismulti=1`);
      const getst = resstate.json();
      setCopyToList(await getst);
    };
    getCopyToDropdown().then();
  }, [selectCopyTo]);
  const handleCopyToChange = (obj) => {
    setDateStr("Please click Search button to refresh data.");
    setSearchStatus(0);
    setSelectCopyTo(
      Array.isArray(obj) ? obj.map((x) => x.value).join(",") : []
    );
    setCopyTo({
      value: obj.EmpEmail,
      label: obj.EmpEmail,
    });
  };
   const [errors, setErrors] = useState({});
    const validateForm = () => {
      const errors = {};
  
      if (getSale.length === 0) {
        errors.getSaleErr = "Sales is required";
      }
      if (
        !getDateFrom 
      ) {
        errors.dateFrom =
          "Please input date";
      }
      if (
        !getDateTo
      ) {
        errors.dateTo =
          "Please input date";
      }
      return errors;
    };
   
  const handleSubmit = (event) => {
    event.preventDefault();
    const newErrors = validateForm();
    setErrors(newErrors);
    let containerInputsData = [...containerInputs];
    if (selectPol.length === 0 || selectPod.length === 0) {
      setIsValidPod(false);
      if (selectPol.length === 0) {
        setIsValidPol(false);
      }
      if (selectPod.false === 0) {
        setIsValidPod(true);
      }
    } else if (getDangerous === 1 && files.length === 0) {
      setErrorMessage("Please select atleast a file to upload.");
    } else if (files.length !== 0 && checkUplodaFile==false) {
      setErrorMessage("Please click to upload files");
    } else {
    

      let methodKey = "";
      let porStr;
      let polStr;
      let podStr;
      let delStr;
      let sizeStr;
      let typeStr;

      let copytoStr;
      let carrierStr;
      let filesName;
      if (selectPor.length === 0) {
        porStr = "";
      } else {
        porStr = selectPor;
      }
      if (selectPol.length === 0) {
        polStr = "";
      } else {
        polStr = selectPol;
      }
      if (selectPod.length === 0) {
        podStr = "";
      } else {
        podStr = selectPod;
      }
      if (selectDel.length === 0) {
        delStr = "";
      } else {
        delStr = selectDel;
      }

      if (selectCarrier.length === 0) {
        carrierStr = "";
      } else {
        carrierStr = selectCarrier;
      }

      if (selectCopyTo.length === 0) {
        copytoStr = "";
      } else {
        copytoStr = selectCopyTo;
      }
      if (files.length === 0) {
        filesName = "";
      } else {
        filesName = getFileName;
      }
     if (Object.keys(newErrors).length > 0) {
        alert("Please input date")
     } else {
      setButtonDisabled(false);
      methodKey = "POST";
      var data = {
        BUSINESS_ID: selectBusinessType,
        SHIPPER_ID: selectShipper,
        SHIPPER_DETAIL: getShipperDetail,
        ETD_FROM: getDateFrom,
        ETD_TO: getDateTo,
        COUNTRY: selectOrigin,
        POL: polStr,
        POD: podStr,
        DESTINATION: selectDestination,
        POR: porStr,
        DEL: delStr,
        COMMODITY: selectCommodity,
        COMMODITY_DETAIL: getCommodityDetail,
        HS_CODE: getHSCODE,
        CONTAINER_SIZE: "",
        QUANTITY: qty,
        CONTAINER_TYPE: "",
        TEU_NOTE: "",
        DANGEROUS: getDangerous,
        DG_CLASS: getDG,
        WEIGHT: weight,
        DIMENSION: dimension,
        CBM: getCMB,
        PACKAGE_TYPE: packageType,
        TARGET_RATE: targetRate,
        CARRIER: carrierStr,
        EXPECT_ETD: getExpectEtd,
        REQUEST_STATUS: selectStatus,
        REMARK: remark,
        REMARK_TO_CARRIER: getRemarkToCarrier,
        ATTACHMENT: filesName,
        SALESID: selectSale,
        COPY_TO: copytoStr,
        USERID: getUserID,
        STATUS_ID: "1",
        UPDATE_BY: getUserID,
        UPDATE_DATE: "",
        CONTAINER_INPUT: containerInputsData,
      };
      fetch(api_path + "/TS_SALES_INQUIRY.php", {
        method: methodKey,
        headers: {
          Accept: "application/form-data",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((result) => {
          if (result["status"] == "200") {
            swal("Done.", "Save data successfully.", "success", {
              buttons: true,
              timer: 5000,
            }).then(function () {
              const url =
                api_path +
                "/SENDMAIL_NEWINQUIRY.php?INQUIRY_ID=" +
                result["message"];
              axios
                .get(url)
                .then((response) => {
                  // handle success
                  setcontainerInputs([]);
                  setButtonDisabled(true);
                  console.log(result["message"]);
                })
                .then((data) => {
                  console.log(data);
                  // Handle data
                })
                .catch((error) => {
                  // handle errors
                  setButtonDisabled(true);
                });
              window.location =
                "./SaleInquiryDetail?param1=" + result["message"] + "&param2=2";
            });
          } else {
            swal("Sorry", result["message"], "error", {
              buttons: true,
              timer: 5000,
            }).then(function () {
              setButtonDisabled(true);
            });
          }
        });
      }
    }
  };
  const optionsTopics = [
    {
      value: "1",
      label: "ไม่มีราคาในระบบ No rate in system",
    },
    {
      value: "2",
      label: "มีราคาในระบบ แต่ต้องการต่อรองราคา ",
    },
    {
      value: "3",
      label: "ต้องการข้อมูลสายเรืออื่นเพิ่ม เพื่อการเปรียบเทียบราคา",
    },
  ];
  const optionsContainerSize = [
    { value: "20", label: "20" },
    { value: "40", label: "40" },
    { value: "45", label: "45" },
  ];
  const optionsContainerType = [
    { value: "DC", label: "DC" },
    { value: "FR", label: "FR" },
    { value: "OT", label: "OT" },
    { value: "RF", label: "RF" },
    { value: "HC", label: "HC" },
    { value: "BULK", label: "BULK" },
  ];
  const [checked, setChecked] = React.useState(false);
  const [getRequire, setRequire] = useState();
  const handleChangeCheck = (event) => {
    setChecked(event.target.checked);
    setDangerous(1);
    setShowDG(true);
    if (event.target.checked) {
      setRequire("required");
      console.log("✅ Checkbox is checked");
      setDangerous(1);
      setShowDG(true);
    } else {
      setRequire("");
      console.log("⛔️ Checkbox is NOT checked");
      setDangerous(0);
      setShowDG(false);
    }
  };

  function checkIsAllowedType(selectedFiles) {
    const allowedTypes = [".jpg", ".jpeg", ".png", ".gif", ".pdf", ".doc", ".docx", ".xls", ".xlsx",".csv"];
    return selectedFiles.some((file) => {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      return allowedTypes.includes(`.${fileExtension}`);
    });
  }
  const [errorMessage, setErrorMessage] = useState("");
   const [files, setFiles] = useState([]);
    const [getFileName, setFileName] = useState([]);
    const [selectedfile, SetSelectedFile] = useState([]);
    const filesizes = (bytes, decimals = 2) => {
      if (bytes === 0) return "0 Bytes";
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    };
    const InputChange = (e) => {
      setShowUploadMsg("⚠️ Pressing the Upload button.");
      const selectedFiles = Array.from(e.target.files);
      var totalSize = 0;
      for (let i = 0; i < e.target.files.length; i++) {
        const file = selectedFiles[i];
        SetSelectedFile((preValue) => {
          return [
            ...preValue,
            {
              id: i,
              filename: e.target.files[i].name,
              filetype: e.target.files[i].type,
              filesize: filesizes(e.target.files[i].size),
            },
          ];
        });
        if (file) {
          totalSize += parseInt(file.size);
        }
      }
      const maxSize = 30 * 1024 * 1024; // 30MB
      if (totalSize > maxSize) {
        setErrorMessage("File size exceeds. It should be less than 30MB.");
        setShowUploadMsg("");
      } else {
        const isAllowedFiles = checkIsAllowedType(selectedFiles);
        if (!isAllowedFiles) {
          setErrorMessage(
              "Please select file jpg, jpeg, png, gif, pdf, doc ,docx, xls, xlsx, csv ."
          );
          setShowUploadMsg("");
        } else {
          setErrorMessage("");
          const commaString = selectedFiles.map((item) => GET_RANDOM_KEY+"_"+item.name).join(",");
          setFileName(commaString.replaceAll(" ", ""));
          setFiles(selectedFiles);
        }
      }
    };
  const handleFileUpload = async () => {
    if (files.length === 0) {
      setErrorMessage("Please select atleast a file to upload.");
      setShowUploadMsg("");
      return;
    }
    setErrorMessage("");
    console.log("files ..." + files);
    handleMultipleFileUploadAjax(files);
  };
  async function handleMultipleFileUploadAjax(
    files
  ) {
    try {
      const formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        const newName = GET_RANDOM_KEY+"_"+ files[i].name;  
        formData.append("file[]", files[i],newName.replaceAll(" ", ""));
      }
      const response = await axios.post(api_path + "/SALE_INQUIRY_UPLOAD.php", formData, {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
        },
      });
      if (response.data.status == "200") {
        setShowUploadMsg("✅ Uploaded successfully!");
        setUplodaFile(true)
      } else {
        setShowUploadMsg("❌ Upload failed!");
        setUplodaFile(false)
      }
    } catch (error) {
      setShowUploadMsg("❌ Upload failed!");
      console.error(error);
      setUplodaFile(false)
    }
  }
  const handleKeyDown = (event, callback) => {
    if (event.key === "Enter" && event.shiftKey === false) {
      event.preventDefault();
    }
  };

  const handleAddInput = () => {
    setcontainerInputs([
      ...containerInputs,
      { getContainerSize: "", getContainerType: "", qty: "", TEU_NOTE: "" },
    ]);
  };
  const handleChange = (option, index, name) => {
    const value = option.value;
    const list = [...containerInputs];
    list[index][name] = value;
    setcontainerInputs(list);
  };
  const handleChangeTextbox = (event, index) => {
    let { name, value } = event.target;
    let onChangeValue = [...containerInputs];
    onChangeValue[index][name] = value;
    setcontainerInputs(onChangeValue);
  };
  const handleDeleteInput = (index) => {
    const newArray = [...containerInputs];
    newArray.splice(index, 1);
    setcontainerInputs(newArray);
  };
  function readableBytes(bytes) {
    var i = Math.floor(Math.log(bytes) / Math.log(1024)),
      sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    return (bytes / Math.pow(1024, 2)).toFixed(2) * 1 + " " + sizes[2];
  }
  return (
    <Container maxWidth="md" className="BorderBox">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          &nbsp;
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <label className="head">{subjectName}</label>
      </Grid>
      <form
        onSubmit={handleSubmit}
        onKeyDown={(e) => {
          handleKeyDown(e, handleSubmit);
        }}
      >
        <Grid mb={2} container spacing={2}>
          <Grid item xs={12} sm={4}>
            <label>REQUEST BY</label>
            <p>{getUserID}</p>
          </Grid>
          <Grid item xs={12} sm={4}>
            <label>SALES IN CHARGE</label>
            <span className="red">*</span>

            <Select
              placeholder="Select..."
              value={getSale}
              options={saleList}
              onChange={handleSaleChange}
              getOptionLabel={(x) => x.EmpEmail}
              getOptionValue={(x) => x.EmpEmail}
              required
            />
              {errors.getSaleErr && (
                    <span className="error-message">{errors.getSaleErr}</span>
                  )}
          </Grid>
          <Grid item xs={12} sm={4}>
            <label>CC TO</label>
            <MultiSelect
              styles={{
                menu: (provided) => ({ ...provided, zIndex: 10000000 }),
              }}
              options={copyToList}
              defaultValue={[]}
              value={copyToList.filter((obj) =>
                selectCopyTo.includes(obj.value)
              )}
              onChange={handleCopyToChange}
              labelledBy="Select"
              hasSelectAll={false}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <label>VALID FROM</label>
            <span className="red">*</span>
            <DateBox
              styles={{
                menu: (provided) => ({ ...provided, zIndex: 9999 }),
              }}
              //defaultValue={now}
              inputAttr={dateLabel}
              type="date"
              displayFormat="dd/MM/yyyy"
              value={getDateFrom}
              min={now}
              onValueChanged={onValueChangedDateFrom} 
            />
              {errors.dateFrom && (
                    <span className="error-message">{errors.dateFrom}</span>
                  )}
          </Grid>
          <Grid item xs={12} sm={6}>
            <label>TO</label>
            <span className="red">*</span>
            <DateBox
              //defaultValue={now}
              inputAttr={dateLabel}
              type="date"
              displayFormat="dd/MM/yyyy"
              value={getDateTo}
              min={getMinDate}
              onValueChanged={onValueChangedDateTo}
            />
             {errors.dateTo && (
                    <span className="error-message">{errors.dateTo}</span>
                  )}
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <hr className="underline" />
        </Grid>
        <Grid mb={2} container spacing={2}>
          <Grid item xs={12} sm={4}>
            <label>COUNTRY</label>
            <span className="red">*</span>
            <Select
              styles={{
                menu: (provided) => ({ ...provided, zIndex: 9999 }),
              }}
              placeholder="Select..."
              value={getOrigin}
              options={originList}
              onChange={handleOriginChange}
              getOptionLabel={(x) => x.COUNTRY_NAME}
              getOptionValue={(x) => x.COUNTRY_CODE}
              required
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <label>POR</label>

            <MultiSelect
              defaultValue={[]}
              options={porList}
              value={porList.filter((obj) => selectPor.includes(obj.value))}
              onChange={handlePorChange}
              labelledBy="Select"
              hasSelectAll={false}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <label>POL</label>
            <span className="red">*</span>
            <MultiSelect
              defaultValue={[]}
              options={polList}
              value={polList.filter((obj) => selectPol.includes(obj.value))}
              onChange={handlePolChange}
              labelledBy="Select"
              hasSelectAll={false}
              required
            />
            <span className="red">
              {!isValidPol && <p>You must choose a value</p>}
            </span>
          </Grid>

          <Grid item xs={12} sm={4}>
            <label>DESTINATION</label>
            <span className="red">*</span>
            <Select
              styles={{
                menu: (provided) => ({ ...provided, zIndex: 9999 }),
              }}
              placeholder="Select..."
              value={getDestination}
              options={destinationList}
              onChange={handleDestinationChange}
              getOptionLabel={(x) => x.COUNTRY_NAME}
              getOptionValue={(x) => x.COUNTRY_CODE}
              required
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <label>POD</label>
            <span className="red">*</span>
            <MultiSelect
              defaultValue={[]}
              options={podList}
              value={podList.filter((obj) => selectPod.includes(obj.value))}
              onChange={handlePodChange}
              labelledBy="Select POD"
              hasSelectAll={false}
              required
            />
            <span className="red">
              {!isValidPod && <p>You must choose a value</p>}
            </span>
          </Grid>
          <Grid item xs={12} sm={4}>
            <label>DEL</label>
            <MultiSelect
              defaultValue={[]}
              options={podList}
              value={podList.filter((obj) => selectDel.includes(obj.value))}
              onChange={handleDelChange}
              labelledBy="Select DEL"
              hasSelectAll={false}
            />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <hr className="underline" />
        </Grid>
        <Grid mb={2} container spacing={2}>
          <Grid item xs={12} sm={6}>
            <label>SHIPPER NAME</label>
            <span className="red">*</span>
            <Select
              styles={{
                menu: (provided) => ({ ...provided, zIndex: 9999 }),
              }}
              placeholder="Select..."
              value={getShipper}
              options={shipperList}
              onChange={handleShipperChange}
              getOptionLabel={(x) => x.CUSTOMER_NAME}
              getOptionValue={(x) => x.CRM_CUSCODE}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            {showShipperDetail && (
              <Grid item xs={12} sm={12}>
                {showShipperDetail && <label> Please fill shipper name:</label>}
                {showShipperDetail && (
                  <TextField
                    size="small"
                    name="shipperDetail"
                    variant="outlined"
                    fullWidth
                    id="shipperDetail"
                    value={getShipperDetail}
                    onChange={(e) => setShipperDetail(e.target.value)}
                    required
                  />
                )}
              </Grid>
            )}
            {showShipperDetail && (
              <Grid item xs={12} sm={6}>
                &nbsp;
              </Grid>
            )}
          </Grid>
          <Grid item xs={12} sm={3}>
            <label>COMMODITY</label>
            <span className="red">*</span>
            <Select
              placeholder="Select..."
              value={getCommodity}
              options={commodityList}
              onChange={handleCommodityChange}
              getOptionLabel={(x) => x.COMMODITY_NAME}
              getOptionValue={(x) => x.COMMODITY_NAME}
              required
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <label>COMMODITY DETAILS</label>
            <span className="red">*</span>
            <TextField
              size="small"
              name="commodityDetail"
              variant="outlined"
              fullWidth
              id="commodityDetail"
              value={getCommodityDetail}
              onChange={(e) => setCommodityDetail(e.target.value)}
              required
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <label>HS CODE</label>
            <TextField
              size="small"
              name="HS_CODE"
              variant="outlined"
              fullWidth
              id="HS_CODE"
              value={getHSCODE}
              onChange={(e) => setHSCODE(e.target.value)}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <FormGroup row style={{ display: "flex", flexDirection: "row" }}>
              <FormControlLabel
                control={<Checkbox />}
                label="DANGEROUS GOODS"
                onChange={handleChangeCheck}
              />
            </FormGroup>
          </Grid>
          {showDG && (
            <Grid item xs={12} sm={6}>
              <label className="red">
                MSDS file is required to attach for DG shipment
              </label>
            </Grid>
          )}
          <Grid item xs={12} sm={3}>
            {showDG && <label> DG CLASS/UN NO:</label>}
            {showDG && (
              <TextField
                size="small"
                name="DG"
                variant="outlined"
                fullWidth
                id="DG"
                value={getDG}
                onChange={(e) => setDG(e.target.value)}
                required
              />
            )}
          </Grid>

          <Grid item xs={12}>
            <hr className="underline" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <label>BUSINESS TYPE</label>
            <span className="red">*</span>
            <Select
              styles={{
                menu: (provided) => ({ ...provided, zIndex: 9999 }),
              }}
              placeholder="Select..."
              value={getBusinessType}
              options={businessTypeList}
              onChange={handleBusinessTypeChange}
              getOptionLabel={(x) => x.INQUIRY_MASTER_EN}
              getOptionValue={(x) => x.INQUIRY_MASTER_VALUE}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            &nbsp;
          </Grid>
        </Grid>

        <Grid mb={2} container spacing={2}>
          {showTEU && (
            <Grid item xs={12} sm={12}>
              {containerInputs.map((item, index) => (
                <Grid container spacing={2} key={index}>
                  <Grid item xs={12} sm={2}>
                    <label>SIZE</label>
                    <span className="red">*</span>
                    <Select
                      placeholder="Select..."
                      name="getContainerSize"
                      value={item.value}
                      options={optionsContainerSize}
                      onChange={(event) =>
                        handleChange(event, index, "getContainerSize")
                      }
                      required
                    />
                    {/* <MultiSelect
              defaultValue={[]}
              options={optionsContainerSize}
              value={optionsContainerSize.filter((obj) =>
                selectContainerSize.includes(obj.value)
              )}
              onChange={handleContainerSizeChange}
              labelledBy="Select"
              hasSelectAll={false}
            /> */}
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <label>TYPE</label>
                    <span className="red">*</span>
                    <Select
                      placeholder="Select..."
                      name="getContainerType"
                      value={item.value}
                      options={optionsContainerType}
                      onChange={(event) =>
                        handleChange(event, index, "getContainerType")
                      }
                      required
                    />
                    {/* <MultiSelect
              options={optionsContainerType}
              defaultValue={[]}
              value={optionsContainerType.filter((obj) =>
                selectContainerType.includes(obj.value)
              )}
              onChange={handleContainerTypeChange}
              labelledBy="Select"
              hasSelectAll={false}
            /> */}
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <label>CONTAINER VOL.</label>
                    <span className="red">*</span>
                    <TextField
                      size="small"
                      name="qty"
                      variant="outlined"
                      fullWidth
                      value={item.value}
                      type="number"
                      inputProps={{ min: 0 }}
                      onChange={(event) => handleChangeTextbox(event, index)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                <label>WEIGHT PER UNIT(kgs.)</label>
                <span className="red">*</span>
                <TextField
                  size="small"
                  name="weight"
                  variant="outlined"
                  fullWidth
                  id="weight"
                  value={weight}
                  onChange={(e) => setWeight(e.target.value)}
                  required
                />
              </Grid>
                  <Grid item xs={12} sm={3}>
                    <label>NOTE</label>
                    <TextField
                      size="small"
                      name="TEU_NOTE"
                      variant="outlined"
                      fullWidth
                      value={item.value}
                      onChange={(event) => handleChangeTextbox(event, index)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={1}>
                    {containerInputs.length > 1 && (
                      <DeleteIcon
                        onClick={() => handleDeleteInput(index)}
                        style={{
                          marginRight: "10px",
                          marginTop: "35px",
                          cursor: "pointer",
                        }}
                      />
                    )}
                    {index === containerInputs.length - 1 && (
                      <AddBoxIcon
                        onClick={handleAddInput}
                        style={{ marginTop: "37px", cursor: "pointer" }}
                      />
                    )}
                  </Grid>
                </Grid>
              ))}
            </Grid>
          )}
          {showDimension && (
            <Grid mb={2} container spacing={2} className="boxContainnerType">
              <Grid item xs={12} sm={3}>
                <label>DIMENSION (W x D x H)(CM)</label>
                <span className="red">*</span>
                <TextField
                  size="small"
                  name="dimension"
                  variant="outlined"
                  fullWidth
                  id="dimension"
                  value={dimension}
                  onChange={(e) => setDimension(e.target.value)}
                  required
                />
              </Grid>

              <Grid item xs={12} sm={3}>
                <label>QTY</label>
                <span className="red">*</span>
                <TextField
                  size="small"
                  name="qty"
                  variant="outlined"
                  fullWidth
                  value={qty}
                  type="number"
                  inputProps={{ min: 0 }}
                  onChange={(e) => setQty(e.target.value)}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <label>WEIGHT PER UNIT(kgs.)</label>
                <span className="red">*</span>
                <TextField
                  size="small"
                  name="weight"
                  variant="outlined"
                  fullWidth
                  id="weight"
                  value={weight}
                  onChange={(e) => setWeight(e.target.value)}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <label>CBM</label>
                <span className="red">*</span>
                <TextField
                  size="small"
                  name="CMB"
                  variant="outlined"
                  fullWidth
                  id="CBM"
                  value={getCMB}
                  onChange={(e) => setCMB(e.target.value)}
                  required
                />
              </Grid>
              {showPackageType && (
                <Grid item xs={12} sm={3}>
                  <label>PACKAGE TYPE</label>
                  <span className="red">*</span>
                  <TextField
                    size="small"
                    name="packageType"
                    variant="outlined"
                    fullWidth
                    id="packageType"
                    value={packageType}
                    onChange={(e) => setPackageType(e.target.value)}
                    required
                  />
                </Grid>
              )}
              <Grid item xs={12} sm={9}>
                &nbsp;
              </Grid>
            </Grid>
          )}
         <Grid item xs={12} sm={12}>
            <div>Please comment for below request by return.</div>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <hr className="underline" />
        </Grid>
        <Grid mb={2} container spacing={2}>
          <Grid item xs={12} sm={6}>
            <label>TARGET RATE</label>
            <TextField
              size="small"
              name="targetRate"
              variant="outlined"
              fullWidth
              id="targetRate"
              value={targetRate}
              onChange={(e) => setTargetRate(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <label>Expect ETD date / ETA</label>
            <TextField
              size="small"
              name="getExpectEtd"
              variant="outlined"
              fullWidth
              id="getExpectEtd"
              value={getExpectEtd}
              onChange={(e) => setExpectEtd(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <label>CARRIER</label>
            <MultiSelect
              options={carrierList}
              value={carrierList.filter((obj) =>
                selectCarrier.includes(obj.value)
              )}
              onChange={handleCarrierChange}
              labelledBy="Select"
              hasSelectAll={false}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <label>REQUEST REASON</label>
            <span className="red">*</span>
            <Select
              placeholder="Select..."
              defaultValue={{
                value: "1",
                label: "ไม่มีราคาในระบบ No rate in system",
              }}
              value={getStatus}
              options={optionsTopics}
              onChange={handleStatusChange}
              required
            />
          </Grid>

          <Grid item xs={12} sm={12}>
            <label>REMARK TO PRICING</label>
            <TextField
              size="small"
              name="remark"
              fullWidth
              id="remark"
              value={remark}
              variant="outlined"
              onChange={(e) => setRemark(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <label>REMARK TO CARRIER</label>
            <TextField
              size="small"
              name="getRemarkToCarrier"
              fullWidth
              id="getRemarkToCarrier"
              value={getRemarkToCarrier}
              variant="outlined"
              onChange={(e) => setRemarkToCarrier(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
     
     <label>Attach file</label>
     <div className="kb-file-upload">
       <div className="file-upload-box">
         <input
           type="file"
           id="fileupload"
           className="file-upload-input"
           onChange={InputChange}
           multiple
         />
         <span>
           Drag and drop or{" "}
           <span className="file-link">Choose your files</span>
         </span>
       </div>
     </div>
     <div className="kb-attach-box mb-3">
       {selectedfile.map((data, index) => {
         const { id, filename, filesize } = data;
         return (
           <div className="file-atc-box" key={id}>
             <div className="file-detail">
               <h6>{filename}</h6>
               <p>
                 <span>Size : {filesize}</span>
               </p>
               {/* <div className="file-actions">
                 <button
                   type="button"
                   className="file-action-btn"
                   onClick={() => DeleteSelectFile(id, index)}
                 >
                   Delete before submit
                 </button>
               </div> */}
             </div>
           </div>
         );
       })}
     </div>
     {files.name > 0 ? (
       <div className="kb-attach-box">
         <hr />
         {files.map((data, index) => {
           const { id, filename, filesize } = data;
           return (
             <div className="file-atc-box" key={index}>
               <div className="file-detail">
                 <h6>{filename}</h6>
                 <p>
                   <span>Size : {filesize}</span>
                 </p>
                 {/* <div className="file-actions">
                   <button
                     className="file-action-btn"
                     onClick={() => DeleteFile(id, index)}
                   >
                     Delete
                   </button>
                 </div> */}
               </div>
             </div>
           );
         })}
       </div>
     ) : (
       ""
     )}
     {files && (
       <Button
         type="button"
         variant="outlined"
         color="primary"
         onClick={handleFileUpload}
       >
         &uarr; Click to Upload {files.length > 1 ? "files" : " file"}
       </Button>
     )}
     &nbsp; &nbsp; &nbsp;
     <label>{showUploadMsg}</label>
   </Grid>
          {/* <Grid item xs={12} sm={12}>
            <label>ATTACHED FILE </label> &nbsp;&nbsp;
            <input type="file" multiple onChange={handleFileChange} />
            {files &&
              [...files].map((file, index) => (
                <section key={file.name}>
                  File number {index + 1} details:
                  <ul>
                    <li>Name: {file.name}</li>
                    <li>Type: {file.type}</li>
                    <li>Size: {readableBytes(file.size)}</li>
                  </ul>
                </section>
              ))}
            {files && (
              <Button
                type="button"
                variant="outlined"
                color="primary"
                onClick={handleFileUpload}
              >
                &uarr; Upload {files.length > 1 ? "files" : "a file"}
              </Button>
            )}
            &nbsp; &nbsp; &nbsp;
            <label>{showUploadMsg}</label>
          </Grid> */}
          {errorMessage && (
            <Grid item xs={12} sm={12}>
              <label className="red">{errorMessage}</label>
            </Grid>
          )}

         
          <Grid container className="Box" mb={2}>
            <Grid item xs={12} sm={6}>
              <Button
                isLoading={isSubmitting}
                disabled={!isButtonDisabled}
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
              >
                Save
              </Button>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Button
                type="button"
                fullWidth
                variant="outlined"
                color="primary"
                onClick={goBack}
              >
                &larr; Go Back
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
}
